import { useRef } from "react";
import { TableAndPrices } from "../../../pages/BasketPage/BasketPage.styles";
import PartList, { ColumnAlign, ColumnWidth } from "../../PartsList/PartList";
import React from "react";
import CodeAndDescriptionComponent from "../../PartsList/TableLayout/TableColumnComponents/CodeAndDescriptionComponent";
import ReplaceIconComponent from "../../PartsList/TableLayout/TableColumnComponents/ReplaceIconComponent";
import AvaibilityIconComponent from "../../PartsList/TableLayout/TableColumnComponents/AvaibilityIconComponent";
import QuantityComponent from "../../PartsList/TableLayout/TableColumnComponents/QuantityComponent";
import DiscountComponent from "../../PartsList/TableLayout/TableColumnComponents/DiscountComponent";
import BasketNoItemPage from "../../../pages/BasketPage/BasketNoItemPage";
import PriceFormatComponent from "../../PartsList/TableLayout/TableColumnComponents/PriceFormatComponent";
import { NoteSimpleIconComponent } from "../../PartsList/TableLayout/TableColumnComponents/NoteSimpleIconComponent";
import PartMccLogoComponent from "../../PartsList/TableLayout/TableColumnComponents/PartMccLogoComponent";
import PartSketchThumbnailComponent from "../../PartsList/TableLayout/TableColumnComponents/PartSketchThumbnailComponent";
import useBrands from "../../../../explorer/hooks/useBrands";



type BasketOfferOrderDetailProps = {
    items: any;
    onSubmitItemNote?: any;
    getItemNote?: any;
    typeSubmit: "ORDER" | "OFFER" | "ORDER_FROM_OFFER";
};


export const BasketOfferOrderDetail: React.FC<BasketOfferOrderDetailProps> = ({
    items,
    onSubmitItemNote,
    getItemNote,
    typeSubmit,
}) => {
    // Lista di item nel basket
    const submitNote = (rowId: number, note: string = "") => {};
    const addColumnLogo: boolean =
        useBrands().currentBrand!.manufacturers.length > 1;
    const listDisabledRow = useRef<string[]>([]);
    return (
        <TableAndPrices>
            <PartList
                items={items}
                loading={false}
                emptyPage={BasketNoItemPage}
                columns={[
                    ...(addColumnLogo
                        ? [
                              {
                                  name: "mcc",
                                  viewHeader: false,
                                  width: ColumnWidth.IconWidth,
                                  customComponent: PartMccLogoComponent,
                              },
                          ]
                        : []),
                    {
                        name: "image",
                        viewHeader: false,
                        width: ColumnWidth.IconWidth,
                        customComponent: PartSketchThumbnailComponent,
                    },
                    {
                        name: "codeDescription",
                        viewHeader: true,
                        width: ColumnWidth.TextWidth,
                        customComponent: CodeAndDescriptionComponent,
                        additionalProps: { readonly: true },
                        align: ColumnAlign.Left,
                    },
                    {
                        name: "withreplacement",
                        viewHeader: false,
                        width: ColumnWidth.IconWidth,
                        customComponent: ReplaceIconComponent,
                    },
                    {
                        name: "noteItems",
                        viewHeader: false,
                        width: ColumnWidth.IconWidth,
                        customComponent: NoteSimpleIconComponent,
                        additionalProps: {
                            onSubmitItemNote,
                            getItemNote,
                            typeSubmit,
                        },
                    },

                    {
                        name: "availabilityStatus",
                        viewHeader: false,
                        width: ColumnWidth.IconWidth,
                        customComponent: AvaibilityIconComponent,
                        additionalProps: {},
                    },
                    {
                        name: "qty",
                        viewHeader: true,
                        width: ColumnWidth.ShortTextWidth,
                        additionalProps: {
                            loadingPrices: false,
                            readonly: true,
                        },
                        customComponent: QuantityComponent,
                    },
                    {
                        name: "discount",
                        viewHeader: false,
                        width: ColumnWidth.IconWidth,
                        customComponent: DiscountComponent,
                    },
                    {
                        name: "grossUnitPrice",
                        viewHeader: true,
                        width: ColumnWidth.ShortTextWidth,
                        align: ColumnAlign.Right,
                        customComponent: PriceFormatComponent,
                    },
                    {
                        name: "netTotalPrice",
                        viewHeader: true,
                        width: ColumnWidth.ShortTextWidth,
                        align: ColumnAlign.Right,
                        customComponent: PriceFormatComponent,
                    },
                ]}
            />
        </TableAndPrices>
    );
};


